import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export type SupportChatState = {
  activeChatSession: boolean;
  isMinimized: boolean;
  numUnread: number;
  supportProductInfo?: SupportProductInfo;
};

export enum TravelCategory {
  Flight = "Flight",
  Lodging = "Lodging",
  Home = "Home",
  Ground = "Ground",
  Activities = "Activities",
}

const initialState: SupportChatState = {
  activeChatSession: false,
  isMinimized: true,
  numUnread: 0,
};

export interface SupportProductInfo {
  /**
   * The reservation UUID
   */
  productId: string;
  productType: TravelCategory;
}

const supportChatSlice = createSlice({
  name: "supportChat",
  initialState,
  reducers: {
    /**
     * @description For unmounting the entire ChatWindow component after the
     * chat session is ended
     */
    endChatSession(state: SupportChatState) {
      state.activeChatSession = false;
      state.isMinimized = true;
    },
    minimizeChatWindow(state: SupportChatState) {
      state.isMinimized = true;
    },
    setNumUnread(state: SupportChatState, action: PayloadAction<number>) {
      state.numUnread = action.payload;
    },
    /**
     * @description For minimizing and maximizing the chat window while
     * keeping the chat session active
     */
    toggleChatWindow(state: SupportChatState) {
      if (!state.activeChatSession) {
        state.activeChatSession = true;
      }

      state.isMinimized = !state.isMinimized;
    },
    setSupportProductInfo(
      state: SupportChatState,
      action: PayloadAction<SupportProductInfo | undefined>
    ) {
      state.supportProductInfo = action.payload;
    },
  },
});

const {
  actions: {
    endChatSession,
    minimizeChatWindow,
    setNumUnread,
    setSupportProductInfo,
    toggleChatWindow,
  },
  reducer: supportChatReducer,
} = supportChatSlice;

export {
  endChatSession,
  minimizeChatWindow,
  setNumUnread,
  setSupportProductInfo,
  supportChatReducer,
  toggleChatWindow,
};
